import $http from '../../shared/http';

const groups = {
  namespaced: true,
  state: () => {
    return {
      groupsForSelect: null,
      maxNumberOfGroupsPerMember: 2,
      groupData: null,
      groupFormData: null,
      isGroupEdited: false,
      editedGroupID: null,
      isGroupCreated: null,
      createdGroupID: null,
      isGroupsExist: null,
      existingGroupNames: null,
      membershipByGroupsForDashboard: null,
    };
  },
  getters: {
    getGroupsForSelect: (state) => {
      return state.groupsForSelect && state.groupsForSelect.length
        ? state.groupsForSelect.sort((a, b) => a.text.toUpperCase() - b.text.toUpperCase())
        : null;
    },
    getMaxNumberOfGroupsPerMember: (state) => state.maxNumberOfGroupsPerMember,
    getCurrentGroup: (state) => state.groupData,
    getCurrentGroupID: (state) => (state.groupData ? state.groupData.id : null),
    getGroupEditData: (state) => state.groupData,
    getIsGroupsExist: (state) => state.isGroupsExist,
    getExistingGroupNames: (state) => state.existingGroupNames,
    getMembershipByGroupsForDashboard: (state) => {
      if (!state.membershipByGroupsForDashboard) return {};
      else {
        const dataset = [
          {
            label: 'Brothers',
            backgroundColor: 'rgba(109, 227, 223, 0.66)',
            borderColor: 'transparent',
            data: state.membershipByGroupsForDashboard.map((min) => min.__meta__.brothers),
            barPercentage: 0.5,
            categoryPercentage: 1,
          },
          {
            label: 'Sisters',
            backgroundColor: 'rgba(241, 215, 110, 0.66)',
            borderColor: 'transparent',
            data: state.membershipByGroupsForDashboard.map((min) => min.__meta__.sisters),
            barPercentage: 0.5,
            categoryPercentage: 1,
          },
        ];

        const labels = state.membershipByGroupsForDashboard.map(
          (min) => min.name.slice(0, 9) + '...'
        );

        return { dataset, labels };
      }
    },
  },
  mutations: {
    setGroupsForSelect: (state, payload) => (state.groupsForSelect = payload),
    setCurrentGroup: (state, data) => {
      state.groupData = data;
    },
    setGroupEditData(state, form) {
      state.groupFormData = form;
    },
    setGroupRegisterData(state, form) {
      state.groupFormData = form;
    },
    setGroupData: (state, data) => {
      state.groupData = data;
    },
    setIsGroupsExist: (state, data) => {
      state.isGroupsExist = data;
    },
    setExistingGroupNames: (state, data) => {
      state.existingGroupNames = data;
    },
    setMembershipByGroupsForDashboard: (state, payload) => {
      state.membershipByGroupsForDashboard = payload;
    },
  },

  actions: {
    async LOAD_GROUPS_FOR_SELECT({ commit }, { churchId }) {
      if (!churchId) {
        throw new Error('Church ID not provided');
      }

      return $http('v2')
        .get(`organisations/${churchId}/groups/select`, { canBeImpersonated: true })
        .then((response) => {
          commit('setGroupsForSelect', response.data.data);
          return response;
        });
    },

    async LOAD_GROUP_DATA({ commit }, group_id) {
      commit('setGroupData', null);
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/groups/${group_id}`)
          .then((response) => {
            commit('setGroupData', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async CREATE_GROUP_ACTION(ctx, { form, churchId }) {
      return $http('v2')
        .post(`organisations/${churchId}/groups`, form, {
          headers: { 'X-Is-Notifiable': 'On' },
        })
        .then(async (response) => {
          return response.data.data;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async EDIT_GROUP_ACTION(ctx, { id, form, churchId }) {
      return $http('v2')
        .put(`organisations/${churchId}/groups/${id}`, form, {
          headers: { 'X-Is-Notifiable': 'On' },
        })
        .then(async (response) => {
          return response.data.data;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async DELETE_GROUP_ACTION(ctx, { id }) {
      return $http()
        .delete(`/groups/${id}`, { notifiable: true })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async IS_GROUP_EXIST_ACTION({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        commit('setIsGroupsExist', null);
        await $http()
          .get(`/organisations/${churchId}/groups/check/existence`, { canBeImpersonated: true })
          .then((response) => {
            commit('setIsGroupsExist', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async GET_GROUP_NAMES_ACTION({ commit }) {
      return new Promise(async (resolve, reject) => {
        commit('setExistingGroupNames', null);
        await $http()
          .get('/groups/check/names')
          .then((response) => {
            commit('setExistingGroupNames', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async GET_MEMBERSHIP_BY_GROUPS_FOR_DASHBOARD_ACTION({ commit }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get('/dashboard/membership-by-groups')
          .then((response) => {
            commit('setMembershipByGroupsForDashboard', response?.data?.data);
            resolve(response?.data?.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default groups;
